import { defineStore } from "pinia";

export const useThemeStore = defineStore('theme', {
    state: () => {
        return {
            DarkTheme: false
        }
    },
    persist: {
        storage: localStorage
    },
    getters: {
        getTheme(state): boolean {
            return state.DarkTheme
        }
    },
    actions: {
        updateTheme(darkTheme: boolean) {
            this.DarkTheme = darkTheme
        }
    }
})